import { render, staticRenderFns } from "./EventLocation.vue?vue&type=template&id=42dfabbb&scoped=true&"
import script from "./EventLocation.vue?vue&type=script&lang=js&"
export * from "./EventLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dfabbb",
  null
  
)

export default component.exports